import { useState, useEffect } from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend } from "recharts";
import {
  fetchDailyEmergencyGraph,
  fetchWeeklyEmergencyGraph,
  fetchMonthlyEmergencyGraph,
  fetchAbnormalLogs,
} from "../../services/dashboardService";

const Processing = () => {
  const [tab, setTab] = useState("daily");
  const [data, setData] = useState([]);
  const [key, setKey] = useState("date");
  const [abnormalLogs, setAbnormalLogs] = useState([]); 

  const getDataFromApi = async () => {
    const token = localStorage.getItem("token");
    try {
      let result;
      switch (tab) {
        case "daily":
          result = await fetchDailyEmergencyGraph(token);
          setKey("date");
          break;
        case "weekly":
          result = await fetchWeeklyEmergencyGraph(token);
          setKey("date");
          break;
        case "monthly":
          result = await fetchMonthlyEmergencyGraph(token);
          setKey("date");
          break;
        default:
          return;
      }
      console.log("✅ API 응답 확인:", result);

      if (result?.success) {
        setData(result.data || []); // `graph` 키는 응답 구조에 따라 수정 필요
      } else {
        console.error("그래프 데이터 실패", result?.message);
        setData([]);
      }
    } catch (err) {
      console.error("그래프 요청 오류", err);
      setData([]);
    }
  };

  const getAbnormalLog = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetchAbnormalLogs(token);
      if (res.success === false) {
        alert(res.message || "이상 알림 로그를 불러오지 못했습니다.");
        return;
      }
      setAbnormalLogs(res.log_result || []);
    } catch (error) {
      console.error("🚨 이상 알림 로그 예외:", error);
      alert("이상 알림 로그 요청 중 오류가 발생했습니다.");
    }
  };

  useEffect(() => {
    getDataFromApi();
    getAbnormalLog();
  }, [tab]);

  useEffect(() => {
  console.log("✅ 서버에서 받은 data 확인:", data);
}, [data]);

  const step1Total = data.reduce((sum, item) => sum + Number(item.level_1_count || 0), 0);
  const step2Total = data.reduce((sum, item) => sum + Number(item.level_2_count || 0), 0);

  return (
    <div className="processing dashboard_box">
      <h4>응급상황 처리현황</h4>
      <div className="radio_tabs">
        <label><input type="radio" value="daily" checked={tab === "daily"} onChange={() => setTab("daily")} />일간</label>
        <label><input type="radio" value="weekly" checked={tab === "weekly"} onChange={() => setTab("weekly")} />주간</label>
        <label><input type="radio" value="monthly" checked={tab === "monthly"} onChange={() => setTab("monthly")} />월간</label>
      </div>

      <div className="emergency_chart">
        <ResponsiveContainer width="100%" height={245}>
          <BarChart data={data}>
            <XAxis dataKey={key} />
            <YAxis width={30} />
            <Tooltip />
            <Legend />
            <Bar dataKey="level_1_count" name="1단계" fill="#60a5fa" />
            <Bar dataKey="level_2_count" name="2단계" fill="#34d399" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="emergency_text">
        <ul>
          <li className="t01"><span className="tit">1단계</span><span className="num">{step1Total}명</span></li>
          <li className="t02"><span className="tit">2단계</span><span className="num">{step2Total}명</span></li>
        </ul>
      </div>

      <div className="emergency_alarm">
      {abnormalLogs.length > 0 && (
       <>
        <p className="tit">
            {abnormalLogs[0].json_log}
            <span>{abnormalLogs[0].create_date.slice(0, 10)}</span>
        </p>
        <ul>
            {abnormalLogs.slice(1, 4).map((log) => (
            <li key={log.id}>
                {log.json_log}
                <span>{log.create_date.slice(0, 10)}</span>
            </li>
            ))}
        </ul>
        </>
      )}
    </div>

    </div>
  );
};

export default Processing;
